var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _setup.gridConfiguration
        ? _c(_setup.Grid, {
            attrs: {
              itemData: _setup.documentIntervener,
              gridConfiguration: _setup.gridConfiguration,
              toolbarOptions: _setup.toolbarItemsOptions,
              toolbarClick: _setup.onToolbarClick,
              commandClick: _setup.onCommandClick,
            },
            on: { rowClick: _setup.onRowClick },
          })
        : _vm._e(),
      _c(_setup.PromptDialog, {
        attrs: {
          title: _setup.modalTitle,
          isOpened: _setup.openedPrompt,
          context: _vm.formAlias,
          formSchema: _setup.formSchema,
          formFieldValues: _setup.formData,
          width: 940,
        },
        on: {
          "execute-action": _setup.onExecuteAction,
          changeFormField: _setup.onChangeFormFieldValue,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }